import { BaseVideoClickTracker } from '@/analytics/base_video_click_tracker';

export class TrackVideoClick extends BaseVideoClickTracker {
    getVideoItems() {
        // Right side does not exist on mobile
        const rightItems: HTMLElement[] = Array.from(
            this.$refs['related-videos-right']?.querySelectorAll('.js-video-item') || []
        );
        const bottomItems: HTMLElement[] = Array.from(
            this.$refs['related-videos-bottom']?.querySelectorAll('.js-video-item') || []
        );

        this.videoItems = [...rightItems, ...bottomItems];
    }
}
